// extracted by mini-css-extract-plugin
export default {"collapsible":"collapsible-4aca","collapsed":"collapsed-eccf"};